import React from "react";

const DeleteIcon = (props) => {
  return (
    <svg
      style={{ marginRight: 15 }}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.00016 0.166626C8.1555 0.166626 9.09963 1.07093 9.16343 2.21035L9.16683 2.33329H12.6668C12.943 2.33329 13.1668 2.55715 13.1668 2.83329C13.1668 3.08643 12.9787 3.29562 12.7347 3.32873L12.6668 3.33329H12.1362L11.2828 12.0128C11.1943 12.9122 10.4658 13.6066 9.57523 13.663L9.45823 13.6666H4.54212C3.63839 13.6666 2.87593 13.0096 2.73272 12.1289L2.71759 12.0128L1.8635 3.33329H1.3335C1.08036 3.33329 0.871169 3.14519 0.838063 2.90114L0.833496 2.83329C0.833496 2.58016 1.0216 2.37097 1.26565 2.33786L1.3335 2.33329H4.8335C4.8335 1.13667 5.80356 0.166626 7.00016 0.166626ZM11.1315 3.33329H2.86816L3.71278 11.9149C3.75195 12.313 4.06705 12.6228 4.4574 12.6624L4.54212 12.6666H9.45823C9.8583 12.6666 10.1974 12.3834 10.275 11.9988L10.2876 11.9149L11.1315 3.33329ZM8.16683 5.16663C8.41996 5.16663 8.62916 5.35473 8.6623 5.59878L8.66683 5.66663V10.3333C8.66683 10.6094 8.44296 10.8333 8.16683 10.8333C7.9137 10.8333 7.7045 10.6452 7.67136 10.4012L7.66683 10.3333V5.66663C7.66683 5.39049 7.8907 5.16663 8.16683 5.16663ZM5.8335 5.16663C6.08663 5.16663 6.29583 5.35473 6.32896 5.59878L6.3335 5.66663V10.3333C6.3335 10.6094 6.10963 10.8333 5.8335 10.8333C5.58036 10.8333 5.37117 10.6452 5.33806 10.4012L5.3335 10.3333V5.66663C5.3335 5.39049 5.55736 5.16663 5.8335 5.16663ZM7.00016 1.16663C6.38803 1.16663 5.88603 1.63803 5.83736 2.23761L5.8335 2.33329H8.16683C8.16683 1.68896 7.6445 1.16663 7.00016 1.16663Z"
        fill="#212121"
      />
    </svg>
  );
};

export default DeleteIcon;
